import _ from 'lodash';
const UPLOAD_STAGE = 1;
const CHUNK_SIZE = 5;
const webUploadType = 'WebUpload';
const unmanaged = 'Manual';

class SecureFileUploaderService {
  constructor($http, config, $q, batchService, agentConfigService, sourceErrorsService, localStorageService) {
    this.$http = $http;
    this.config = config;
    this.$q = $q;
    this.batchService = batchService;
    this.agentConfig = {};
    this.agentConfigService = agentConfigService;
    this.sourceErrorsService = sourceErrorsService;
    this.localStorageService = localStorageService;
    this.checkErrors = false;
    this.batchIsInProgress = false;
    this.uploadState = {
      sequence: 1,
      file: null,
      batchId: null,
      completeWithErrors: false,
      workflowStatus: null,
      stages: []
    };
    this.getAgentConfig();
  }

  getAgentConfig() {
    this.agentConfigService.getAgentConfig().then(
      this.onGetAgentConfigSuccess.bind(this),
      this.onGetAgentConfigFailure.bind(this)
    );
  }

  onGetAgentConfigSuccess(response) {
    this.agentConfig = response.data.content;
    //this.updateStages();
  }

  onGetAgentConfigFailure() {
    console.log('There was an error retrieving your agent configuration.');
  }

  isWorkFlowEnabled() {
    const hasCustomerInfo = this.localStorageService.get('impersonatingCustomer');
    return hasCustomerInfo && hasCustomerInfo.useWorkflow;
  }

  updateStages() {
    if(!this.isWorkFlowEnabled()) {
      this.batchService.getWorkflowDefinitions(this.isUnmanagedCustomer() ? 'UNMANAGED_BATCH_UPLOAD' : 'BATCH_UPLOAD').then((response) => {
        this.uploadState.stages = _.chunk(response.data.content, CHUNK_SIZE);
      }, this.onCreateBatchFailure.bind(this));
    } else {
      this.uploadState.stages = null;
    }
  }

  uploadFile(file,batchConfig) {
    return this.batchService.createBatch(webUploadType, false, this.isUnmanagedCustomer(), batchConfig, file).then((response) => {
      const batchId = response && response.data && response.data.content && response.data.content.batchId;
      this.uploadState.batchId = batchId;
      this.uploadState.workflowStatus = 'NEW';
      this.applyBatchChanges({
        id: batchId,
        workflowStatus: 'NEW',
        workflowTransitions: {
          '1': {
            progress: 1
          }
        }
      });
      return this.$q.resolve();
    }, this.onCreateBatchFailure.bind(this));
  }

  getFileContentType(file) {
    return file.type ? file.type : 'application/octet-stream';
  }

  onCreateBatchSuccess() {
    return this.$q.resolve();
  }

  onCreateBatchFailure() {
    return this.$q.reject();
  }

  getUploadState() {
    return this.uploadState;
  }

  isComplete() {
    const noOfStages = this.uploadFile.stages && this.uploadFile.stages.length;
    const noOfStagesCompleted = this.uploadFile.stages && this.uploadFile.stages.filter(a => a.status === 'COMPLETE');

    return noOfStages == noOfStagesCompleted;
  }

  isProcessComplete() {
    return this.uploadState.workflowStatus && (this.uploadState.workflowStatus === 'COMPLETE' || this.uploadState.workflowStatus === 'FAILED' || this.uploadState.workflowStatus === 'CANCELLED');
  }

  isInProgress() {
    return this.isUploadInProgress();
  }

  hasValidateError() {
    return false;
  }

  hasProcessError() {
    return false;
  }

  resetStages() {
    let stages = _.cloneDeep(_.flatten(this.uploadState.stages));
    stages = stages.map(a => {
      a.progress = 0;
      return a;
    });
    this.uploadState.stages = _.chunk(stages, CHUNK_SIZE);
  }

  cancel() {
    this.resetStages();
    this.removeFile();
    this.checkErrors = false;
    this.uploadState.batchId = null;
    this.uploadState.sequence = UPLOAD_STAGE;
    this.uploadState.completeWithErrors = false;
  }

  removeFile() {
    this.uploadState.file = null;
  }

  setError() {
  }

  hasError() {
    return false;
  }

  isWaitingForUpload () {
    return this.uploadState.workflowStatus === null || this.uploadState.workflowStatus && (this.uploadState.workflowStatus === 'COMPLETE' || this.uploadState.workflowStatus === 'FAILED' || this.uploadState.workflowStatus === 'CANCELLED');
  }

  setUpdateStages(stages) {
    this.uploadState.stages = stages;
  }

  applyBatchChanges(lastBatch) {
    if (this.uploadState.batchId === lastBatch.id || this.uploadState.workflowStatus !== 'COMPLETE' && this.uploadState.workflowStatus !== 'FAILED' && this.uploadState.workflowStatus !== 'CANCELLED') {
      let stages = _.cloneDeep(_.flatten(this.uploadState.stages));
      stages = _.map(stages, (stage) => {
        const currentStage = lastBatch.workflowTransitions && lastBatch.workflowTransitions[stage.sequence];
        if (currentStage){
          stage.status = currentStage.status;
          stage.progress = currentStage.progress;
          stage.hasError = currentStage.status === 'FAILED';
          if (stage.sequence === 1 && !this.checkErrors && currentStage.status === 'COMPLETE') {
            this.sourceErrorsService.getErrors().then((response) => {
              const errors = response.data.content;
              if (errors.length > 0) {
                this.uploadState.completeWithErrors = true;
              }
              this.checkErrors = true;
            });
          }
        }
        return stage;
      });
      this.uploadState.stages = _.chunk(stages, CHUNK_SIZE);
    }
    this.uploadState.workflowStatus = lastBatch['workflowStatus'];
  }


  removeError() {
    this.uploadState.hasError = false;
  }

  isUploadInProgress() {
    return this.uploadState.workflowStatus && (this.uploadState.workflowStatus !== 'COMPLETE' && this.uploadState.workflowStatus !== 'FAILED' && this.uploadState.workflowStatus !== 'CANCELLED');
  }

  isUnmanagedCustomer() {
    return this.agentConfig.format === unmanaged;
  }
}

SecureFileUploaderService.$inject = ['$http', 'config', '$q', 'batchService', 'agentConfigService', 'sourceErrorsService', 'localStorageService'];

export default SecureFileUploaderService;



// WEBPACK FOOTER //
// ./app/components/secureFileUploader/secureFileUploader.service.js